<p-card>
  <ng-template pTemplate="header">
    <div class="p-card-title">
      {{component.title}}
      <small *ngIf="showConfigOptions">Component: {{component.code}}, Entity: {{component.entity}}</small>
      <div *ngIf="!showConfigOptions" class="p-card-title-actions">
        <ng-container *ngFor="let action of component.headerActions">
          <a *ngIf="isActionVisible(action, item)" (click)="onActionClick(action, item)" class="{{action.class}}">
            <fa-icon [icon]="action.icon"></fa-icon> {{action.label}}
          </a>
        </ng-container>
        <a (click)="showTracking()" *ngIf="component.show_tracking && configurationPermission">
          <fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
        </a>
      </div>
      <div *ngIf="showConfigOptions" class="p-card-title-actions">
        <ng-content select="[toolbarStart]"></ng-content>
        <ng-content select="[toolbarEnd]"></ng-content>
      </div>
    </div>
  </ng-template>
  <ng-container #customComponentContainer></ng-container>
</p-card>
